const dataSelectArrowDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 3v9.4"/><polyline points="5.5 9.86 8.02 13 10.5 9.92"/></svg>',
};

export { dataSelectArrowDown as default };
